var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AlInput',{on:{"blur":(e) => _vm.$emit('blur', e),"focus":(e) => _vm.$emit('focus', e)}})
}
var staticRenderFns = []

export { render, staticRenderFns }